import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../../providers/GlobalProvider';
import AuditHeaderLayout from 'components/Common/Layouts/AuditHeaderLayout';
import DocumentsTable from 'components/Monitor/Documents/DocumentsTable';
import ActivityComponent from 'components/Monitor/ActivityTab/ActivityComponent';
import SettingsComponent from 'components/Monitor/SettingsTab/SettingsComponent';
import ResultsComponent from 'components/Monitor/ResultsTab/Results';
import CommentsModal from 'components/Monitor/Modals/CommentsModal';
import DeleteCommonModal from 'components/Monitor/Modals/DeleteModal';
import CasesAPI from 'api/CasesAPI';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { Modal } from '@mui/material';
import AddPersonModal from 'components/Monitor/Modals/AddPersonModal';
import UsersAPI from 'api/UsersAPI';
import SupQuestSubmit from 'components/Monitor/Modals/SupQuestSubmit';
import PaymentsAPI from 'api/PaymentsAPI';
import { handleShareTicketNotification } from 'utils/NotificationsFuncs';
import { Typography } from '@mui/material';
import { Player } from '@lottiefiles/react-lottie-player';
import SubscribeModal from 'components/SubscribeModal';
import ClassResultsComponent from 'components/Monitor/ResultsTab/ClassResults';

const Ticket: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const dt = new Date();
  const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
  const [ trigger, setTrigger ] = useState(false);
  const [ ticket_id, setTicketID ] = useState(props.match.params.ticket_id);
  const [ autoTab, setAutoTab ] = useState<string>('Results');
  const [ shareModal, setShareModal ] = useState(false);
  const [ owner, setOwner ] = useState('');
  const [ triggerCSV, setTriggerCSV ] = useState(false);
  const [ supQuestModal, setSupQuestModal ] = useState(false);
  const [ screeningCus, setScreeningCus ] = useState({ isLoading: true, data: '' });
  const [ userHasMonitor, setUserHasMonitor ] = useState(false);
  const [ activeSub, setActiveSub ] = useState(false);
  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] =
    useState<string>('');

  const [ cur_case, setCase ] = useState<{
      isLoaded: boolean;
      error: string | undefined;
      data: any;
    }>({ isLoaded: false, error: undefined, data: {} });

  const [ isCommentsModalOpen, setIsCommentsModalOpen ] = useState(false);
  const [ isDeleteModalOpen, setIsDeleteModalOpen ] = useState(false);

  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
    case 'Results':
      setAutoTab('Results');
      window.sessionStorage.setItem('autoTab', 'Results');
      break;
    case 'Documents':
      setAutoTab('Documents');
      window.sessionStorage.setItem('autoTab', 'Documents');
      break;
    case 'Activity':
      setAutoTab('Activity');
      window.sessionStorage.setItem('autoTab', 'Activity');
      break;
    case 'Settings':
      setAutoTab('Settings');
      window.sessionStorage.setItem('autoTab', 'Settings');
      break;
    default:
      setAutoTab('Results');
    }
  };

  useEffect(() => {
    checkForMonitor();
  }, []);

  const checkForMonitor = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('standard') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro')
    ) {
      setUserHasMonitor(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveSub(true);
            }
          });
        }
      });
    }
  };

  const handleDeleteTicket = async() => {
    const resp = await CasesAPI.deleteCase(cur_case.data._id);
    if(resp?.success){
      enqueueSnackbar('Removed case', { variant: 'info' });
      history.push('/bite-monitor');
    }else if(resp){
      const error_msg = `Error removing ticket: ${resp?.result}`;
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const favoriteTicket = async() => {
    const update: any = {
      _id: cur_case.data._id,
      favorite: !cur_case.data.favorite
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
  };

  const addComment = async(content: string) => {
    const comment: any = {
      content: content,
      person: `${cur_user?.basics?.firstName} ${cur_user?.basics?.lastName}`,
      date: formatted_dt,
    };
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: 'added a comment',
      timeStamp: Date.now()
    };
    const update: any = {
      _id: cur_case.data._id,
      comments: [ ...cur_case.data.comments, comment ],
      activity: [ ...cur_case.data.activity, actObj ],
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
  };

  const addShared = async(email: string) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `shared the ticket with ${email}`,
      timeStamp: Date.now()
    };
    const update: any = {
      _id: cur_case.data._id,
      sharedWith: [ ...cur_case.data.sharedWith, email ],
      activity: [ ...cur_case.data.activity, actObj ]
    };
    const res = await CasesAPI.updateCase(update);
    if (res?.success) {
      handleShareTicketNotification(cur_case.data.ticketName, cur_user, email, cur_case.data._id);
      enqueueSnackbar('Successfully shared your ticket', { variant: 'success' });
    } else {
      const error_msg = 'Error sharing your ticket';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
    setTrigger(!trigger);
  };

  const removeComment = async(arr: any) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: 'removed a comment',
      timeStamp: Date.now()
    };
    const update: any = {
      _id: cur_case.data._id,
      comments: [ ...arr ],
      activity: [ ...cur_case.data.activity, actObj ]
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
  };


  const helpContent = (
    <p className='module-header-tooltip-text'>
      Review the results or manage any aspect of your ticket from this page. The tabs will take you to new information or functionality.
    </p>
  );
  const getOwner = async(id: string) => {
    const res = await UsersAPI.getUser(id);
    if (res?.success) {
      setOwner(res?.result.basics.email);
    }
  };

  const getCusFromEmail = async() => {
    const res = await PaymentsAPI.getCustomerByEmail(
      cur_user.selected_team.attributes.team_admin[0]
    );
    if (res?.success) {
      res?.result?.data?.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setScreeningCus({ isLoading: false, data: cus });
        }
      });
    }
  };

  useEffect(() => {
    getCusFromEmail();
  }, []);


  useEffect(() => {
    if (ticket_id) {
      CasesAPI.getCase(ticket_id)?.then((res: any) => {
        if(res?.success){
          if (res.result.owner?.email !== cur_user.basics?.email && !res.result.sharedWith.includes(cur_user.basics?.email) && !res.result.sharedWith.includes(cur_user.basics?.id) && !(res.result.createdBy === cur_user.basics?.id)) {
            history.push('/');
          }
          setCase({ isLoaded: true, error: undefined, data: res.result });
          if (res.result.owner) {
            setOwner(res.result.owner?.email);
          } else {
            getOwner(res.result.createdBy);
          }
          if (res.result.docType === 'Supplier Questionnaire' && res.result.supQuestReady && !(res.result.results?.length > 0)) {
            setSupQuestModal(true);
          }
        } else {
          const err_text = `Error loading case: ${res?.result}`;
          enqueueSnackbar(err_text, { variant: 'error' });
        }
      });
    } else {
      setCase({ isLoaded: true, error: undefined, data: {} });
    }
  }, [ ticket_id, trigger ]);

  if(!cur_case.isLoaded){
    return (
      <AuditHeaderLayout
        title={''}
        helpContent={helpContent}
        fav={false}
        shareModal={false}
        setShareModal={setShareModal}
        cur_case={cur_case}
      >
        <div className='spinner-spacer-table'>
          <div className='loader'>Loading...</div>
        </div>
      </AuditHeaderLayout>

    );
  }

  return (
    <AuditHeaderLayout
      title={cur_case.data.ticketName}
      helpContent={helpContent}
      handleTooltipClick={() => setIsCommentsModalOpen(true)}
      handleDeleteClick={() => setIsDeleteModalOpen(true)}
      handleFavorite={favoriteTicket}
      fav={cur_case.data.favorite}
      handleCSV={() => setTriggerCSV(true)}
      shareModal={shareModal}
      setShareModal={setShareModal}
      cur_case={cur_case}
      userHasMonitor={userHasMonitor}
    >

      {activeSub && !userHasMonitor ? (
        <div className='no-license-modal'>
          <Player
            autoplay
            loop
            src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
            style={{ width: '20%' }}
          ></Player>
          <Typography
            variant='h6'
            className='text-white'
            style={{
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
            }}
          >
            You need an assigned license to access this module
          </Typography>
          <Typography
            variant='h6'
            style={{
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
              marginTop: '20px',
              color: '#BDBEC1',
            }}
          >
            Visit Account &gt; Users &gt; to assign an available license to your
            user or contact your team admin
          </Typography>
        </div>
      ) : !userHasMonitor ? (
        <SubscribeModal
          name='BITE Monitor'
          description='Keep track of all risk reports, investigative analysis and trend reports'
          price={25}
          curUser={cur_user}
          stripeTeam={matchedTeamWithStripe}
          activeSub={activeSub}
        />
      ) : (
        <></>
      )}
      <div className='screening-tabs-container'>
        <div className='screening-tabs-inner'>
          <div
            className={`screening-tab-btn${autoTab === 'Results' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Results')}
          >
            <div
              className={`screening-tab-btn-text${autoTab === 'Results' ? '-selected' : ''
              }`}
            >
              Results
            </div>
          </div>
          <div
            className={`screening-tab-btn${autoTab === 'Documents' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Documents')}
          >
            <div
              className={`screening-tab-btn-text${autoTab === 'Documents' ? '-selected' : ''
              }`}
            >
              Documents
            </div>
          </div>
          <div
            className={`screening-tab-btn${autoTab === 'Activity' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Activity')}
          >
            <div
              className={`screening-tab-btn-text${autoTab === 'Activity' ? '-selected' : ''
              }`}
            >
              Activity
            </div>
          </div>
          <div
            className={`screening-tab-btn${autoTab === 'Settings' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Settings')}
          >
            <div
              className={`screening-tab-btn-text${autoTab === 'Settings' ? '-selected' : ''
              }`}
            >
              Settings
            </div>
          </div>
        </div>
      </div>
      {autoTab === 'Results' && (
        <>
          {cur_case.data.docType !== 'Classification' ?
            <ResultsComponent
              cur_user={cur_user}
              cur_case={cur_case}
              trigger={trigger}
              setTrigger={setTrigger}
              setShareModal={setShareModal}
              setIsCommentsModalOpen={setIsCommentsModalOpen}
              triggerCSV={triggerCSV}
              setTriggerCSV={setTriggerCSV}
              screeningCus={screeningCus}
            /> :
            <ClassResultsComponent
              cur_user={cur_user}
              cur_case={cur_case}
              trigger={trigger}
              setTrigger={setTrigger}
              triggerCSV={triggerCSV}
              setTriggerCSV={setTriggerCSV}
            />}
        </>
      )}
      {autoTab === 'Documents' && (
        <>
          <DocumentsTable
            tableName={'Ticket Documents'}
            cur_case={cur_case}
            trigger={trigger}
            setTrigger={setTrigger}
            screeningCus={screeningCus}
          />
        </>
      )}
      {autoTab === 'Activity' &&
      <ActivityComponent
        cur_case={cur_case}
        handleTabSwitch={handleTabSwitch}
        owner={owner}
        setShareModal={setShareModal}
      />}

      {autoTab === 'Settings' && (
        <SettingsComponent
          cur_case={cur_case}
          trigger={trigger}
          setTrigger={setTrigger}
          setAutoTab={setAutoTab}
          cur_user={cur_user}
        />
      )}
      <Modal
        open={isCommentsModalOpen}
        onClose={() => setIsCommentsModalOpen(false)}
      >
        <CommentsModal
          handleTooltipClick={() => setIsCommentsModalOpen(false)}
          comments={cur_case.data.comments}
          addComment={addComment}
          removeComment={removeComment}
          cur_user={cur_user}
          cur_case={cur_case}
          trigger={trigger}
          setTrigger={setTrigger}
        />
      </Modal>
      <Modal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <DeleteCommonModal
          handleClose={() => setIsDeleteModalOpen(false) }
          handleDelete={handleDeleteTicket}
          title={'Delete Ticket?'}
          paragraph={'Once Deleted there is no way to recover this ticket or the infomation saved on it.'}/>
      </Modal>
      <Modal
        open={shareModal}
        onClose={() => setShareModal(false)}
      >
        <AddPersonModal
          handleClose={() => setShareModal(false)}
          sharedArr={cur_case.data.sharedWith}
          owner={owner}
          addShared={addShared}
        />
      </Modal>
      <Modal
        open={supQuestModal}
        onClose={() => setSupQuestModal(false)}
      >
        <SupQuestSubmit
          cur_case={cur_case.data}
          handleClose={() => setSupQuestModal(false)}
          handleTabSwitch={handleTabSwitch}
          screeningCus={screeningCus}
        />
      </Modal>
    </AuditHeaderLayout>
  );
};

export default Ticket;
